import React from "react";

import {FIELD_TYPE, tabKeys, TT_PHIEU_VTYT} from "types/enums";
import {DataFormField} from "types/models/input-field-type";

import {ColumnProps} from "../../../../../types/models";
import {Input, Select} from "antd";

const {INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER} = FIELD_TYPE;

const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    width: 20,
    align: "center",
    isResizable: true,
  },
  {
    title: "Họ tên",
    key: "hoTen",
    show: true,
    dataIndex: "hoTen",
    width: 150,
    align: "left",
    isResizable: true,
    fixed: "left",
  },
  {
    title: "Mã NV",
    key: "maNhanVien",
    show: true,
    isResizable: true,
    dataIndex: "maNhanVien",
    width: 60,
    align: "left",
    fixed: "left",
  },
  {
    title: "Chức vụ",
    key: "chucVu",
    show: true,
    dataIndex: "chucVu",
    width: 120,
    align: "left",
    isResizable: true,
    fixed: "left",
  },
  {
    title: "Năm",
    key: "",
    show: true,
    disabledCheck: true,
    dataIndex: "nam",
    align: "center",
    className: "white",
    // children :[
    //   {
    //     title: "21",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day21",
    //         show: true,
    //         dataIndex: "day21",
    //         width: 50,
    //         align: "center"


    //       }
    //     ]
    //   },
    //   {
    //     title: "22",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day22",
    //         show: true,
    //         dataIndex: "day22",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "23",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day23",
    //         show: true,
    //         dataIndex: "day23",
    //         width: 50,
    //         align: "center",


    //       }
    //     ]
    //   },
    //   {
    //     title: "24",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day24",
    //         show: true,
    //         dataIndex: "day24",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "25",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day25",
    //         show: true,
    //         dataIndex: "day25",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "26",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day26",
    //         show: true,
    //         dataIndex: "day26",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "27",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day27",
    //         show: true,
    //         dataIndex: "day27",
    //         width: 50,
    //         align: "center",


    //       }
    //     ]
    //   },
    //   {
    //     title: "28",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day28",
    //         show: true,
    //         dataIndex: "day28",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "29",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day29",
    //         show: true,
    //         dataIndex: "day29",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "30",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day30",
    //         show: true,
    //         dataIndex: "day30",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "31",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day31",
    //         show: true,
    //         dataIndex: "day31",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "1",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day1",
    //         show: true,
    //         dataIndex: "day1",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "2",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day2",
    //         show: true,
    //         dataIndex: "day2",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "3",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day3",
    //         show: true,
    //         dataIndex: "day3",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "4",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day4",
    //         show: true,
    //         dataIndex: "day4",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "5",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day5",
    //         show: true,
    //         dataIndex: "day5",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "6",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day6",
    //         show: true,
    //         dataIndex: "day6",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "7",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day7",
    //         show: true,
    //         dataIndex: "day7",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "8",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day8",
    //         show: true,
    //         dataIndex: "day8",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "9",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day9",
    //         show: true,
    //         dataIndex: "day9",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "10",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day10",
    //         show: true,
    //         dataIndex: "day10",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "11",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day11",
    //         show: true,
    //         dataIndex: "day11",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "12",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day12",
    //         show: true,
    //         dataIndex: "day12",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]

    //   },
    //   {
    //     title: "13",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day13",
    //         show: true,
    //         dataIndex: "day13",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "14",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day14",
    //         show: true,
    //         dataIndex: "day14",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "15",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day15",
    //         show: true,
    //         dataIndex: "day15",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "16",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day16",
    //         show: true,
    //         dataIndex: "day16",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "17",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day17",
    //         show: true,
    //         dataIndex: "day17",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "18",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day18",
    //         show: true,
    //         dataIndex: "day18",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    //   {
    //     title: "19",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day19",
    //         show: true,
    //         dataIndex: "day19",
    //         width: 50,
    //         align: "center",
    //       }
    //     ]
    //   },
    //   {
    //     title: "20",
    //     key: "",
    //     show: true,
    //     dataIndex: "",
    //     width: 50,
    //     align: "center",
    //     children:[
    //       {
    //         title: "T2",
    //         key: "day20",
    //         show: true,
    //         dataIndex: "day20",
    //         width: 50,
    //         align: "center",

    //       }
    //     ]
    //   },
    // ]
  },
  {
    title: "Số giờ làm việc chuẩn",
    key: "soGioLamViecChuan",
    show: true,
    dataIndex: "soGioLamViecChuan",
    width: 60,
    align: "right",
    isResizable: true,
  },
  {
    title: "Số phút đi muộn",
    key: "soPhutDiMuon",
    show: true,
    dataIndex: "soPhutDiMuon",
    width: 60,
    align: "right",
    fixed: "right",
    isResizable: true,
  },


];

const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Phòng",
    name: "phong",
    disable: false,
  },
  {
    type: INPUT,
    label: "Mã NV",
    name: "maNhanVien",
    disable: false,
  },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    disable: false,
  },
  {
    type: COMBO_BOX,
    name: "thang",
    label: "Tháng",
    disable: false,
    options: listMonths,
    rules: [{ required: true, message: "Vui lòng chọn tháng" }],
  },
  {
    type: COMBO_BOX,
    name: "nam",
    label: "Năm",
    disable: false,

    options: listYears,
    rules: [{ required: true, message: "Vui lòng chọn năm" }],

  },
];

export {allColumns, itemsInputField};
